module.exports = __webpack_public_path__ + "img/20200515_opportunity_for_education_industry_digital_transformation.d3e64f1e.jpg";